<template>
    <div class="auditInformation">
        <div class="search">
            <el-select v-model="params.status" placeholder="请选择">
                <el-option v-for="item in statusList" :key="item.name" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <el-date-picker class="joinTime" value-format="yyyy-MM-dd HH:mm:ss" v-model="time" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions" type="datetimerange"></el-date-picker>
            <el-input class="phone" v-model.trim="params.phone" placeholder="输入手机号"></el-input>
            <el-button @click.native="search">搜索</el-button>
        </div>
        <el-table ref="multipleTable" :data="tableData" style="width: 100%">
            <el-table-column label="头像/昵称">
                <template slot-scope="scope">
                    <div class="imgNmae">
                        <div class="imgBox">
                            <img :src="scope.row.headimageurl" alt="">
                        </div>
                        <span>{{scope.row.name}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="mobileno" width="165px" label="手机号码" class-name="center"></el-table-column>
            <el-table-column prop="parentname" label="邀请人" class-name="center">
                <template slot-scope="scope">
                    <div class="parentname">
                        <span v-if="scope.row.parentname">{{scope.row.parentname}}</span>
                        <span v-else>--</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="申请时间" class-name="center"></el-table-column>
            <el-table-column prop="leveltypetext" label="申请推广员等级" class-name="center"></el-table-column>
            <el-table-column prop="brokeragerate" label="操作" class-name="right">
                <template slot-scope="scope">
                    <div class="action">
                        <div class="untreated" v-if="scope.row.status === 1">
                            <span class="agree" @click="agreeAudit(scope.row)">通过</span>
                            <span class="line">|</span>
                            <span class="reject" @click="rejectAudit(scope.row)">拒绝</span>
                        </div>
                        <div class="worked">
                            <span v-if="scope.row.status === 11">已经拒绝</span>
                            <span v-if="scope.row.status === 10">已经通过</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <AgreeAudit ref="agreeAudit" @getList='GetAuditList' @agree="agree"></AgreeAudit>
        <RejectAudit ref="rejectAudit" @getList='GetAuditList'></RejectAudit>
        <Page :total="total" ref="page"></Page>
    </div>
</template>
<script>
import Page from '@/base/page/page'
import AgreeAudit from './agreeAudit'
import RejectAudit from './rejectAudit'
import {auditList} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'auditInformation',
    data() {
        return {
            params: {
                status: '',
                beginTime: '',
                endTime: '',
                phone: ''
            },
            time: '',
            statusList: [
                {code: '', name: '全部状态'},
                {code: '1', name: '申请中'},
                {code: '11', name: '已拒绝'}
            ],
            tableData: [],
            total: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    created() {
    },
    mounted() {
        this.GetAuditList()
    },
    methods: {
        agreeAudit(row) {
            this.$refs.agreeAudit.agreeAudit(row)
        },
        rejectAudit(row) {
            this.$refs.rejectAudit.rejectAudit(row)
        },
        agree(v) {
            this.$emit('agree', v)
        },
        GetAuditList() {
            this.setLoading(true)
            auditList({
                data: Object.assign({}, this.params, this.$refs.page.page),
                success: data => {
                    let v = false
                    data.data.forEach(obj => {
                        if (obj.status === 1) {
                            v = true
                        }
                    })
                    this.$emit('auditMsg', v)
                    this.setLoading(false)
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        search() {
            this.GetAuditList()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'time': {
            handler(newV, oldV) {
                if (!newV) {
                    this.params.beginTime = ''
                    this.params.endTime = ''
                } else {
                    this.params.beginTime = newV[0]
                    this.params.endTime = newV[1]
                }
            }
        }
    },
    components: {
        AgreeAudit, RejectAudit, Page
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
    .auditInformation{
        .search{
            margin-top: 15px;
            .el-select{
                width: 152px;
                margin-right: 30px;
                .el-input__suffix{
                    .el-input__icon{
                        line-height: 32px;
                    }
                }
            }
            .joinTime{
                margin-right: 30px;
                width: 224px;
                .el-input__icon{
                    line-height: 24px;
                }
                .el-range-separator{
                    line-height: 22px;
                }
            }
            .phone{
                margin-right: 30px;
                width: 330px;
            }
            .el-date-editor{
                .el-input__prefix{
                    .el-input__icon{
                        line-height: 32px;
                    }
                }
            }
        }
        .el-table{
            margin-top: 20px;
            .imgNmae{
                display: flex;
                align-items: center;
                .imgBox{
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    img{
                        width:50px;
                        height: 50px;
                        border-radius: 50%;
                    }
                }
            }
            .right{
                .cell{
                    text-align: right;
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            .action{
                .untreated{
                    color: #409EFF;
                    .line{
                        margin: 5px;
                    }
                    .agree, .reject{
                        cursor: pointer;
                    }
                }
                .worked{
                    color: #909399;
                }
            }
        }
    }
</style>
